import React from 'react';

import { Nullable } from '@clearverify/types';

import { useTestVerificationRequestQuery } from 'src/api';

import { useCurrentUserPermissions } from '../user';

type TestVerificationRequestByIdHookParams = {
  skip?: boolean;
};

export const useTestVerificationRequest = (
  inboxItemId: Nullable<string>,
  params: TestVerificationRequestByIdHookParams = {},
) => {
  const { isPlatformAdmin } = useCurrentUserPermissions();

  const { data, loading } = useTestVerificationRequestQuery({
    variables: {
      inboxItemId: String(inboxItemId),
    },
    skip: !!params.skip || !inboxItemId || !isPlatformAdmin,
  });

  const testVerificationRequest = React.useMemo(
    () => data?.testVerificationRequest,
    [data?.testVerificationRequest],
  );

  return {
    testVerificationRequest,
    loading,
  };
};
